import { PlusIcon } from '@heroicons/react/24/outline';
import { useBoolean } from 'usehooks-ts';

import {
  NEW_USER_BUTTON_TEST_ID,
  NEW_USER_DIALOG_TEST_ID,
  USER_MANAGEMENT_TITLE_TEST_ID
} from '@pages/UserManagement/constants';
import { Restricted } from 'containers/Restricted';

import { PrimaryButton } from '@atoms/buttons/PrimaryButton';

import { NewUserDialog } from './NewUser/NewUserDialog';
import { userManagementT as translations } from './translations';

export const UserManagementHeader = () => {
  const {
    value: isNewUserDialogOpen,
    setTrue: openNewUserDialog,
    setFalse: closeNewUserDialog
  } = useBoolean(false);

  return (
    <div className="flex h-10 w-full flex-row items-center justify-between">
      <div
        className="text-2xl font-medium"
        data-testid={USER_MANAGEMENT_TITLE_TEST_ID}
      >
        {translations.title}
      </div>
      <Restricted requiredPermission="users:manage">
        <PrimaryButton
          data-testid={NEW_USER_BUTTON_TEST_ID}
          onClick={openNewUserDialog}
        >
          <PlusIcon className="size-4 stroke-current" />
          {translations.actions.addNewUser}
        </PrimaryButton>

        <NewUserDialog
          open={isNewUserDialogOpen}
          data-testid={NEW_USER_DIALOG_TEST_ID}
          onClose={closeNewUserDialog}
        />
      </Restricted>
    </div>
  );
};
